import React, { Component } from 'react'
import { Link } from 'react-router-dom';

import _ from 'lodash'
import moment from 'moment'
import { getPost } from '../../api/butterCMS'
import { Error404 } from '../../pages'
import { ContentBlock } from '../../components'
import { calculateReadTime } from '../../components/Blog/functions';
import { Helmet } from 'react-helmet';
import { defaultAppTitle } from '../../config/functions';
import { LoadingSpinner } from '../../components/Global';

export default class BlogPost extends Component {

    constructor(props) {
        super(props)

        this.state = {
            article: false,
            postMeta: false,
            isLoading: true
        }
    }

    componentDidMount() {
        this.getPost()
    }

    componentDidUpdate(previousProps) {
        if ( !_.isEqual( previousProps.match.params, this.props.match.params ) ) {
            this.getPost()
        }
    }

    getPost() {
        const { slug } = this.props.match.params

        getPost( slug ).then(({ data: article, meta }) => {
            this.setState({ 
                article,
                meta,
                isLoading: false 
            })

        })
        .catch(error => {
            this.setState({isLoading: false})
        })
    }

    render() {
        const { article, postMeta, isLoading } = this.state
        const { next_post, previous_post } = postMeta

        if (isLoading) {
            return (
                <ContentBlock className="content-block content-block--fullscreen">
                    <LoadingSpinner />
                </ContentBlock>
            )
        }
        
        if (!article) {
            return <Error404 />
        }

        return (
                <article className="c-article">
                    <Helmet>
                        <title>{`${article.seo_title} // Blog // ${defaultAppTitle}`}</title>
                        <meta name="description" content={article.meta_description} />
                        <meta name="og:description" content={article.meta_description} />
                        <link rel="stylesheet" href="/assets/css/prism.css" />
                        <script src="/assets/js/prism.js"></script>
                        <script type="application/ld+json">
                        {`
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": 
                            [
                                {   
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Blog",
                                    "item": "https://davidwalker.info/blog"
                                },
                                {
                                "@type": "ListItem",
                                "position": 2,
                                "name": "${article.title}",
                                "item": "https://davidwalker.info/blog/${article.slug}"
                                }
                            ]
                        }
                        `}
                        </script>
                        <script type="application/ld+json">
                        {`
                        {
                            "@context": "https://schema.org",
                            "@type": "NewsArticle",
                            "mainEntityOfPage": {
                                "@type": "WebPage",
                                "@id": "https://google.com/article"
                            },
                            "headline": "${article.title}",
                            "image": [
                                "${article.featured_image}"
                            ],
                            "datePublished": "${article.published}",
                            "dateModified": "${article.updated}",
                            "author": {
                                "@type": "Person",
                                "name": "David Walker"
                            }
                        }
                        `}
                        </script>
                    </Helmet>

                    <ContentBlock className="content-block content-block--hero">
                        <h1 className="epsilon">
                            <a href={'/blog'} className="u-unstyled">Blog</a>
                            {` // ${article.title}`}
                        </h1>
                        <h2 className="c-article__summary beta">{article.summary}</h2>

                        <div className="c-article__author">
                            <p className="u-no-bm epsilon">
                                {`${moment(article.published).format('LL')} // ${calculateReadTime(article.body)} read`}
                            </p>
                        </div>
                    </ContentBlock>

                    {article.featured_image ?
                        <ContentBlock className="content-block content-block--hero">
                            <div className="c-article__featured-img">
                                <img src={article.featured_image} alt={article.featured_image_alt} />
                            </div>                    
                        </ContentBlock>
                    : ''}

                    <ContentBlock className="c-article__content content-block content-block--article body-text">
                        <div dangerouslySetInnerHTML={{__html: article.body}}></div>
                    </ContentBlock>

                    <ContentBlock className="c-article__content content-block content-block--article">
                        <div className="c-article__related-posts">
                            <div className="c-article__signpost">
                                {previous_post ?
                                    <div>
                                        <strong>Previous Article /</strong>
                                        <Link to={`/blog/${previous_post.slug}`}>
                                            {previous_post.title}
                                        </Link>    
                                    </div>
                                : ''}
                            </div>
                                
                            <div className="c-article__signpost">
                                {next_post ?
                                    <div>
                                        <strong>Next Article /</strong>
                                        <Link to={`/blog/${next_post.slug}`}>
                                            {next_post.title}
                                        </Link>   
                                    </div>
                                : ''}
                            </div>

                        </div>

                        <hr />

                        <div className="c-signpost u-margin--top-double u-text-center">
                            <Link className="c-signpost__link c-signpost__link--inline gamma" to="/blog">Back to blog</Link>
                        </div>
                        
                    </ContentBlock>

                </article>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/blog/post.js